export const buyerInfo = {
    hostOrganizationUUID : "",
    userID : 0,
    CurrentUserUPN:'', 
    CurrentUserEmail:'',
    CurrentUserFirstName:'',
    CurrentUserLastName:'',
    ExternalSourceName:'',
    CurrentUserOrgName: '',
    SpAppName:'',
    FormServicesUrl: '',
    FormsAPIToken: '',
    FormAPIAppID: '',
    CampaignMicroserviceUrl :'',
    IsBulkUserUploadCampaignEnabled: 'false',
    BulkUserUploadCampaignMicorserviceUrl: '',
    IsCampaignEnabled : 'false',
    IsGroupEnabled: 'false',
    reportingToolUrl: '',
    MagUrl: ''
}